
import { Vue, Component, Watch, Model, Prop } from 'vue-property-decorator';
// import { IShopStaffConfig } from '@/common/interface/shop';
import ShopService from '@/services/shop.service';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

@Component({})
export default class StaffField extends Vue {
  isVisible = false;

  isLoading = false;

  val: any = {};

  get isReady() {
    if (!Object.keys(this.val).length) {
      return false;
    }
    return true;
  }

  roleMap: any = {
    合伙人: 1,
    店长: 2,
    收银员: 3,
    老板: 4,
  };

  get sortedKey() {
    if (!Object.keys(this.val).length) {
      return [];
    }
    const fields = ['收银员', '店长', '合伙人'];


    const keys = Object.keys(this.val);
    const kernel = fields.filter((item) => {
      return keys.indexOf(item) > -1;
    });
    const diff = keys.filter((item: string) => kernel.indexOf(item) === -1);
    const sortedKeyList = [...kernel, ...diff];
    return sortedKeyList;
  }

  get disabled() {
    if (!this.toAddMember.name || !this.toAddMember.phone) {
      return true;
    }

    return !this.testPhoneValid();
  }

  toAddMember = {
    phone: '',
    name: '',
  };

  @Prop({
    default: () => {
      return '';
    },
  })
  shopId!: string;

  @Model()
  value!: { [key: string]: any };

  @lazyInject(CarService)
  carService!: CarService;

  @lazyInject(ShopService)
  protected shopService!: ShopService;

  @Watch('value')
  watchValue() {
    this.val = Object.assign({}, this.value);
  }

  testPhoneValid(): boolean {
    return /^1[3-9]\d{9}$/.test(this.toAddMember.phone);
  }

  showDeleteConfirm(params: {
    role: string;
    username: string;
    phone: string;
    userId: number;
  }) {
    const { role, username, phone } = params;
    this.$confirm({
      title: '是否删除门店子账号操作权限?',
      content: `${role}：${username}（${phone}）`,
      okText: '确认删除',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => this.delMember(params),
      onCancel: () => { },
    });
  }

  /** 新增子账号 */
  async addMember() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;

    try {
      const res = await this.carService.addCarShopAddRelation({
        car_shop_id: this.shopId,
        user_phone: this.toAddMember.phone,
        name: this.toAddMember.name,
        role_id: 3,
      });

      if (res) {
        this.$message.success(res);
        await this.fetchStaff();
        this.close();
      }
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  }

  async delMember(params: {
    role: string;
    username: string;
    phone: string;
    userId: number;
  }) {
    const res = await this.carService.delCarShopDeleteRelation({
      car_shop_id: this.shopId,
      group: params.role,
      userId: params.userId,
      role_id: this.roleMap[params.role],
    });
    if (res) {
      this.$message.success(res);
       this.$emit('forceRefresh');
      // await this.fetchStaff();
    }
  }

  async fetchStaff() {
    if (!this.shopId) {
      return;
    }
    const res = await this.shopService.shopStaff(this.shopId);
    if (res) {
      this.val = { ...res };
      this.$emit('forceRefresh');
    }
  }

  close() {
    this.isVisible = false;
    this.toAddMember = {
      phone: '',
      name: '',
    };
  }

  mounted() {
    this.watchValue();
    this.$emit('updateSubmittable', true);
  }
}
